import { Component } from '@angular/core';

@Component({
  selector: 'app-cta-banner-redesign',
  templateUrl: './cta-banner-redesign.component.html',
  styleUrls: ['./cta-banner-redesign.component.scss']
})
export class CtaBannerRedesignComponent {

}
